import { render, staticRenderFns } from "./ContactConfirm.vue?vue&type=template&id=6dd874de&"
import script from "./ContactConfirm.vue?vue&type=script&lang=js&"
export * from "./ContactConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports